import React from 'react';
import type {NotificationRuleSimpleResponse} from 'src/api/ProactApiClient';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {TableToolbar} from 'src/design/molecules/TableToolbar';
import {PermissionGuard} from 'src/app/security/authorization/PermissionGuard';
import {SidebarLinkNotificationRules} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {NotificationRulesTable} from 'src/app/notification-rules/NotificationRulesTable/NotificationRulesTable';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {NotificationRuleDocumentTitle} from '../notificationRuleHelpers';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const NotificationRuleListPage: React.FC = () => {
  useSetDocumentTitle(NotificationRuleDocumentTitle);
  const navigate = useAppNavigate();

  const handleNavigateToNotificationRule = (
    row: NotificationRuleSimpleResponse
  ) => {
    navigate(PathUtility.NotificationRuleView(row.id));
  };

  return (
    <ContentWrapper>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkNotificationRules.icon}
          subtitle="Manage notifications throughout the system">
          Notification Rules
        </PageHeader.Title>
      </PageHeader>
      <NotificationRulesTable
        identifier="notification-rules-list"
        onViewRowClick={handleNavigateToNotificationRule}
        actionBarPostNode={
          <PermissionGuard
            module={ModuleEnum.NotificationRules}
            operation={PermissionOperationEnum.Create}>
            <TableToolbar.Action
              variant="create"
              onClick={() => navigate(PathUtility.NotificationRuleCreate())}
            />
          </PermissionGuard>
        }
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.NotificationRule(),
  element: <NotificationRuleListPage />,
  module: ModuleEnum.NotificationRules,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default NotificationRuleListPage;
